import { t } from "ttag";

import type { LegacyDrill } from "metabase/visualizations/types";
import type { DatasetColumn } from "metabase-types/api";

export const ResultSortAction: LegacyDrill = ({ question, clicked = {} }) => {
  if (
    !clicked ||
    clicked.value !== undefined ||
    !clicked.column ||
    question._card.display !== "table"
  ) {
    return [];
  }

  const { column } = clicked;

  const { handleResultSortClick, columnId } = clicked as {
    handleResultSortClick?: (type: string, column: DatasetColumn) => void;
    columnId?: string;
  };

  if (!handleResultSortClick || !columnId) {
    return [];
  }

  return [
    {
      name: "sort asc",
      title: "Sort ascending",
      section: "summarize",
      buttonType: "horizontal",
      icon: "arrow_up",
      tooltip: t`Sort ascending`,
      type: "custom" as const,
      defaultAlways: false,
      onClick: () => {
        handleResultSortClick("asc", column);
      },
    },
    {
      name: "sort desc",
      title: "Sort descending",
      section: "summarize",
      buttonType: "horizontal",
      icon: "arrow_down",
      tooltip: t`Sort descending`,
      type: "custom" as const,
      defaultAlways: false,
      onClick: () => {
        handleResultSortClick("desc", column);
      },
    },
  ];
};
